export function isYouTubeTimeCommand(command) {
    if (!command || typeof command !== 'object') return false

    const commandName =
        typeof command.command === 'string' ? command.command.trim().toLowerCase() : ''
    const params = command.params == null ? '' : String(command.params).trim()

    return commandName === '!time' && params.length > 0
}
